import { fetcher } from '@commenda/utils';
import {
  AM_TP_DEMO_ROUTES,
  TAmDemoApplyRollForwardRequest,
  TAmDemoApplyRollForwardResponse,
  TAmDemoResult,
} from './types';

/**
 * Rolls the agreement forward into the next fiscal year.
 *
 * Both answers write a version: "nothing changed" refreshes the dates and approves, "something changed" drafts a
 * new agreement for review. Clicking twice returns the same version rather than minting another.
 */
export async function applyAmTpDemoRollForward(
  body: TAmDemoApplyRollForwardRequest
): Promise<TAmDemoResult<TAmDemoApplyRollForwardResponse>> {
  try {
    const response = await fetcher(AM_TP_DEMO_ROUTES.applyRollForward, {
      method: 'POST',
      body,
    });

    if (!response.ok) {
      return { success: false, error: 'Failed to roll the agreement forward' };
    }

    return {
      success: true,
      data: (await response.json()) as TAmDemoApplyRollForwardResponse,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to roll the agreement forward',
    };
  }
}
